module.exports = __webpack_public_path__ + "img/FI28583949.5db119ab.png";